import { Alert } from '@zarya/ui';
import { t } from '@app/i18n';
import { withEmphasis } from '@app/i18n/emphasis';
import { PolicyClaimConditions } from './PolicyClaimConditions';
import type { ClaimCondition } from './PolicyModel';
import s from './Policies.module.css';

export interface PolicyConditionsTabProps {
  claims: ClaimCondition[];
  onClaimsChange: (claims: ClaimCondition[]) => void;
  editable: boolean;
}

/**
 * Aba **Condições** do drawer (T12, FR-080, FR-085b).
 *
 * As condições valem para tudo que a política concede — não por capability.
 *
 * LISTA VAZIA NÃO É «QUALQUER UM» (03/09)
 *
 *   Era a leitura antiga, e ela descrevia o dado em vez do efeito. No modelo
 *   Human × Identity Access o eixo workload é só o contrato da identidade, e o
 *   que esta aba escreve é o eixo pessoa: sem nenhuma condição, a regra não diz
 *   nada sobre quem pede e não entra na interseção — ela é **inerte**. Por isso
 *   a regra ativa exige ao menos uma condição, e não só a de «todas as
 *   identidades» (P6.2).
 *
 * UM EDITOR SÓ (28/08)
 *
 *   Até aqui a aba tinha, acima da lista, três controles fixos: **Tipo de Human
 *   Subject** (customer/employee/prospect), **Canal** (URA/SSO) e **Exigir
 *   autenticação** (amr). Eles são o vocabulário da **Vivo**, não do produto: um
 *   cliente cujo STS emita `pf`/`pj` em `subject_type` recebia três campos que não
 *   servem para nada — e nenhum lugar óbvio para escrever o que serve.
 *
 *   Com as condições por claim (D-7c) o mesmo se diz sem campo fixo:
 *   `subject_type em [customer]`. Os três nomes continuam **sugeridos** no editor,
 *   com os valores que o STS/PDP do lab entende, então quem está no roteiro diário
 *   escolhe da lista em vez de digitar. Sugestão, não vocabulário.
 *
 *   O contrato manteve os três campos (deprecados) e o backend continua
 *   convertendo-os ao publicar: política gravada antes desta mudança não perde a
 *   restrição — ela reaparece aqui já na forma de claim.
 */
export function PolicyConditionsTab({
  claims,
  onClaimsChange,
  editable,
}: PolicyConditionsTabProps) {
  return (
    <div className={s.aba}>
      <PolicyClaimConditions claims={claims} onChange={onClaimsChange} editable={editable} />

      <Alert tone="info" title={t('humanAccess.conditions.where.title')}>
        {withEmphasis(t('humanAccess.conditions.where.body'))}
      </Alert>
    </div>
  );
}
